import React from "react"
import details from "./details"
import Card from "./Card"
import "./testimonial.css"
import "./CarouselCard.css"

function CreateCard(detail) {
  return (
    <Card
      key={detail.id}
      src={detail.src}
      name={detail.name}
      position={detail.position}
      content={detail.content}
    />
  )
}

const Testimonials = () => {
  const btnpressprev = () => {
    const box1 = document.querySelector(".product-container")
    const width1 = box1.clientWidth
    box1.scrollLeft -= width1
  }

  const btnpressnext = () => {
    const box = document.querySelector(".product-container")
    const width = box.clientWidth
    box.scrollLeft += width
  }
  return (
    <div className="product-carousel">
      <div>
        <h1 className="heading">Testimonials</h1>
      </div>
      <button className="pre-btn" onClick={btnpressprev}>
        <p>&lt;</p>
      </button>
      <button className="next-btn" onClick={btnpressnext}>
        <p>&gt;</p>
      </button>
      <div className="product-container">{details.map(CreateCard)}</div>
    </div>
  )
}
export default Testimonials
